import {LensModel} from '../../../../models/api/lensModel';

// Sort the lenses in team namespaces _at the end_, unless we should alphabetize.
export const lensesWorkspaceSortComparator = (lens: LensModel) => lens.name.toLowerCase();
